import React from 'react';
import styled from 'styled-components';
import { workflow } from '@config';

const StyledSection = styled.section`
  ${({ theme }) => theme.mixins.section};
  background-color: var(--ink-900);
  background-image: radial-gradient(700px 420px at 88% 0%, rgba(86, 112, 246, 0.28), transparent 60%);
  color: var(--on-dark-soft);

  .eyebrow {
    color: var(--blue-bright);
  }
`;

const StyledInner = styled.div`
  ${({ theme }) => theme.mixins.container};
`;

const StyledHead = styled.div`
  max-width: 720px;
  margin-bottom: 54px;

  h2 {
    color: #ffffff;
  }

  p {
    color: var(--on-dark-soft);
  }

  @media (max-width: 768px) {
    margin-bottom: 36px;
  }
`;

const StyledGrid = styled.ol`
  ${({ theme }) => theme.mixins.resetList};
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;
  counter-reset: step;

  @media (max-width: 1080px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const StyledStep = styled.li`
  counter-increment: step;
  padding: 28px 26px;
  border: 1px solid var(--on-dark-line);
  border-radius: var(--radius-lg);
  background: rgba(255, 255, 255, 0.03);
  transition: var(--transition);

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(86, 112, 246, 0.5);
    background: rgba(86, 112, 246, 0.08);
  }

  &:before {
    content: '0' counter(step);
    display: block;
    margin-bottom: 16px;
    font-family: var(--font-mono);
    font-size: var(--fz-lg);
    font-weight: 600;
    background: var(--gradient);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }

  h3 {
    margin: 0 0 8px;
    color: #ffffff;
    font-size: var(--fz-lg);
  }

  p {
    margin: 0;
    color: var(--on-dark-soft);
    font-size: var(--fz-sm);
    line-height: 1.6;
  }
`;

const Directions = () => (
  <StyledSection id="directions">
    <StyledInner>
      <StyledHead>
        <p className="eyebrow">Направления работы</p>
        <h2>Как ведётся работа над проектом</h2>
        <p>
          Понятный процесс от первой встречи до запуска и сопровождения: без скрытых этапов и
          неожиданностей.
        </p>
      </StyledHead>

      <StyledGrid>
        {workflow.map(step => (
          <StyledStep key={step.title}>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </StyledStep>
        ))}
      </StyledGrid>
    </StyledInner>
  </StyledSection>
);

export default Directions;
